module.exports = __webpack_public_path__ + "img/bubble-left.4cb85689.svg";